import { z } from "zod";

export const deviceEventSchema = z.strictObject({
  secondsSincePowerOn: z.uint32().describe("When the event occurred"),
  level: z
    .enum(["error", "info", "debug"])
    .describe("The severity of the event"),
  message: z.string().describe("The event message"),
});

export type DeviceEvent = z.infer<typeof deviceEventSchema>;
